import { CustomerRepresentativeFilters } from 'reduxStore/reducers/OrdersSlice/types';
import { OrderTypesEnum } from './enums';
import { OrderFilters } from './types';
import { MyExecutorsFiltersFormValues } from 'pages/Executors/MyExecutors/MyExecutorsFiltersForm/types';

export const determinateTabIndex = (type: OrderTypesEnum): number | null => {
  for (let i = 0; i < Object.keys(OrderTypesEnum).length; i++) {
    if (Object.values(OrderTypesEnum)[i] === type) return i + 1;
  }
  return null;
};

export const determinateOrdersFiltersCount = (searchParameters: OrderFilters): number => {
  let count = 0;
  if (searchParameters.cities?.length) count++;
  if (searchParameters.customId) count++;
  if (searchParameters.clients?.length) count++;
  if (searchParameters.create_date?.startDate) count++;
  return count;
};

export const determinateMyExecutorsFiltersCount = (
  searchParameters: MyExecutorsFiltersFormValues
): number => {
  let count = 0;
  if (searchParameters.fullName) count++;
  if (searchParameters.tin) count++;
  if (searchParameters.ftsStatusName?.length) count++;
  return count;
};

export const determinateCustomerRepresentativeFiltersCount = (
  searchParameters: CustomerRepresentativeFilters
): number => {
  let count = 0;
  if (searchParameters.initiators.length) count++;
  return count;
};
